import script from "./FamilyHome.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyHome.vue?vue&type=script&setup=true&lang=js"

import "./FamilyHome.vue?vue&type=style&index=0&id=3d1a698e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1a698e"]])

export default __exports__